﻿//event perso
//sendedEmailEvent = quand on envoi un email
//receptionEmailEvent = quand on a recu des emails

window.page = null;
window.jaugeDemarrage = null;
window.forcerFermetureNavigateur = false;
window._idxPage = Math.floor(Math.random() * 1000000)
window.pageActive = true
window.mStartConfiguration = function () {
    //if (typeof demarrageExt == 'undefined' || !demarrageExt) {
    //    //demarrageExt est intialisé sur demarrageExt.js pour spécifié qu'on est en externe (dans ce cas, on ne cherche pas récupérer la position)
    //    mGetPositionUser()
    //}
    ////initTouchHandler()

    //if ('serviceWorker' in navigator) {
    //    navigator.serviceWorker.register('/keepalive.js').then(function (registration) {
    //        console.log('ServiceWorker enregistré avec succès');
    //    });
    //}

    //DevExpress.ui.dxScrollView.defaultOptions({
    //    //device: {
    //    //    phone: true
    //    //},
    //    options: {
    //        useNative: false,
    //        bounceEnabled: false,
    //        scrollByContent: true,
    //        scrollByThumb: true
    //    }
    //});

    /*
     * Config dxScrollView (mobile/tablette) + méthode smoothScrollToElement
     * -----------------------------------------------------------------
     * Ajoute smoothScrollToElement() au prototype de dxScrollView : elle devient
     * disponible sur toutes les instances, ex: dxScroll.smoothScrollToElement(element).
     * scrollToElement() d'origine n'est pas touchée.
     *
     * A charger une seule fois, avant la création de tes dxScrollView (même
     * endroit que ton appel à defaultOptions).
     */
    DevExpress.ui.dxScrollView.prototype.smoothScrollToElement = function (element, tempo, onComplete) {
        var scrollView = this;
        tempo = tempo || 300;

        function callComplete() {
            if (typeof onComplete === "function") {
                onComplete();
            }
        }

        var $el = $(element);
        if (!$el.length) {
            callComplete();
            return;
        }

        var $viewport = $(scrollView.element());
        var viewportTop = $viewport.get(0).getBoundingClientRect().top;
        var elementTop = $el.get(0).getBoundingClientRect().top;

        var containerEl = $viewport.find(".dx-scrollable-container").get(0);
        if (!containerEl) {
            callComplete();
            return;
        }

        // Annule une éventuelle animation encore en cours sur ce conteneur
        if (containerEl.__smoothScrollFrame) {
            cancelAnimationFrame(containerEl.__smoothScrollFrame);
            containerEl.__smoothScrollFrame = null;
        }

        // Position réelle lue directement sur le DOM, pas via scrollOffset()
        // du widget (qui ne serait pas à jour puisqu'on contourne son API).
        var startTop = containerEl.scrollTop;
        var targetTop = startTop + (elementTop - viewportTop);
        var startTime = null;

        function finish() {
            containerEl.__smoothScrollFrame = null;
            if (typeof scrollView.scrollTo === "function") {
                scrollView.scrollTo({ top: containerEl.scrollTop, left: containerEl.scrollLeft });
            }
            if (typeof scrollView.update === "function") {
                scrollView.update();
            }
            callComplete();
        }

        function step(now) {
            if (!startTime) {
                startTime = now;
            }
            var progress = Math.min((now - startTime) / tempo, 1);
            var eased = easeInOutQuad(progress);

            containerEl.scrollTop = startTop + (targetTop - startTop) * eased;

            if (progress < 1) {
                containerEl.__smoothScrollFrame = requestAnimationFrame(step);
            } else {
                finish();
            }
        }

        function easeInOutQuad(t) {
            return t < 0.5
                ? 2 * t * t
                : 1 - Math.pow(-2 * t + 2, 2) / 2;
        }

        containerEl.__smoothScrollFrame = requestAnimationFrame(step);
    };
    DevExpress.ui.dxScrollView.defaultOptions({
        device: function (device) {
            return device.phone || device.tablet;
        },
        options: {
            useNative: true, //pour le rajout de bouton dynamique qui bloquait les boutons
            bounceEnabled: false,
            scrollByContent: true,
            scrollByThumb: true
        }
    });
    //DevExpress.ui.dxScrollView.defaultOptions({
    //    device: {
    //        tablet: {
    //            useNative: true,
    //            bounceEnabled: false,
    //            scrollByContent: true,
    //            scrollByThumb: true
    //        },
    //        phone: {
    //            useNative: true,
    //            bounceEnabled: false,
    //            scrollByContent: true,
    //            scrollByThumb: true
    //        }
    //    }
    //});
    DevExpress.ui.dxDateBox.defaultOptions({
        options: {
            type: "date",
            pickerType: "calendar"
        }
    });

    //on gère les ouvertures de doc interne
    $(document).on('click', 'a', function (e) {
        var href = $(this).attr('href');
        if (href && !href.startsWith('#') && !href.startsWith('javascript:')) {
            // Vérifie si le lien est externe (absolu et ne contient pas le domaine actuel)
            if (
                (href.startsWith('http://') || href.startsWith('https://')) &&
                href.includes(window.location.hostname)
            ) {
                console.log("Navigation INTERNE détectée : " + href);
                if (href.startsWith(document.URLRacine + "/fichier/")) {
                    //le lien ouvre un fichier
                    e.preventDefault();
                    debugger;
                    page.mAddPopup({
                        id_fichier: href.replace(document.URLRacine, "~")
                    }, { fullScreen: true })
                } else if (href.endsWith("opendoc")) {
                    debugger;
                    //le lien ouvre un doc de la base
                    e.preventDefault();
                    const segments = href.split('/');
                    const dcrTick = segments[3];
                    const idTable = segments[4];
                    var id = segments[5];
                    if (idTable == 0) {
                        id = id.replace(/-/g, '+').replace(/_/g, '/');
                        while (id.length % 4) { id += '='; }
                        id = decodeURIComponent(escape(atob(id)))
                        var obj = bddMaitre.getObjet("fichier", id)
                        page.mAddPopup(obj.data)
                    } else {
                        var obj = bddMaitre.getObjet(bddMaitre.table.mGetItem(idTable).nom, id)
                        if (obj.data) {
                            if (obj.data.dcr.getDotNetTicks().toString() === normalizeDotNetTicksToMs(dcrTick).toString()) {
                                page.mAddPopup(obj.data)
                            } else {
                                mNotify("Impossible d'ouvrir le document", "warning", 6000)
                            }
                        }
                    }
                }
            }
        }
    });

    if (window.jaugeDemarrage == null) {
        jaugeDemarrage = $("<div class='JAUGEDEMARRAGE'/>").appendTo("body").dxCtrlJauge({ isJaugeDemarrage: true, type: ((typeof parametre == 'undefined') ? "carre" : parametre.typeJauge) }).dxCtrlJauge("instance");
    }
    if (!jaugeDemarrage.isVisible) jaugeDemarrage.mShow(0);


    //pour désactiver la saisie auto
    $("<div style='position:absolute;top:-1000px;'/>").appendTo("body").dxTextBox({
        mode: "email",
        name: "email",
        placeholder: "Saisissez l'adresse email...",
        maxLength: 500,
        width: 1,
        value: ""
    }).dxTextBox("instance");
    dtxTextBoxPwd1 = $("<div style='position:absolute;top:-1000px;'/>").appendTo("body").dxTextBox({
        name: "pwd",
        mode: "password",
        placeholder: "Saisissez le mot de passe...",
        width: 1,
        value: ""
    }).dxTextBox("instance")

    $(document).attr("title", parametre.nom)
    if (document.URLRacine.startsWith("https://portail")) {
        var link = $("link[rel*='icon']").first();
        link.attr("href", parametre.baseAppli.img_logo_portail);
        $(document).attr("title", "Portail " + parametre.baseAppli.nom);
    }

    mReadyTheme(function () {
        mFin()
    })

    function mFin() {
        //message avant fermeture
        $(window).on("beforeunload", function (e) {
            if (!forcerFermetureNavigateur && !parametre.isLocalhost && !isInAppMobile()) return mConfirmFermetureNavigateur(e);
        })

        //function mTooltip() {
        //    $.minimalTips();
        //    function initTooltip($el) {
        //        if (!$el.attr("hastt")) {
        //            $el.attr("hastt", "1");
        //            $.minimalTips($el);
        //        }
        //    }

        //    // Création de l'observer
        //    const observerTitle = new MutationObserver(mutations => {
        //        for (const record of mutations) {

        //            // --- 1) TITLE MODIFIÉ SUR UN ÉLÉMENT EXISTANT ---
        //            if (record.type === "attributes" && record.attributeName === "title") {
        //                initTooltip($(record.target));
        //            }

        //            // --- 2) NOUVEAUX NŒUDS AJOUTÉS AU DOM ---
        //            if (record.type === "childList") {

        //                record.addedNodes.forEach(node => {
        //                    if (node.nodeType !== 1) return;

        //                    const $node = $(node);

        //                    // a) Le noeud ajouté a un title
        //                    if ($node.attr("title")) {
        //                        initTooltip($node);
        //                    }

        //                    // b) Des enfants contiennent déjà des titles
        //                    $node.find("[title]").addBack("[title]").each((i, el) => {
        //                        initTooltip($(el));
        //                    });

        //                    // c) Surveiller aussi les changements d'attributs dans ce nouveau sous-arbre
        //                    observerTitle.observe(node, {
        //                        subtree: true,
        //                        attributes: true,
        //                        childList: true,
        //                        attributeFilter: ["title"]
        //                    });
        //                });
        //            }
        //        }
        //    });

        //    // On limite l'observation uniquement aux attributs "title"
        //    observerTitle.observe(document.body, {
        //        subtree: true,
        //        attributes: true,
        //        childList: true,
        //        attributeFilter: ["title"]
        //    });
        //}

        //if (DevExpress.devices.current().deviceType != "phone" || DevExpress.devices.current().deviceType != "tablet") mTooltip()

        var func = function () {
            if (themeLoaded) {
                DevExpress.ui.dxDataGrid.defaultOptions({
                    device: { deviceType: "desktop" },
                    options: {
                        scrolling: {
                            scrollByContent: false
                        }
                    }
                });
                DevExpress.ui.dxScrollView.defaultOptions({
                    device: { deviceType: "desktop" },
                    options: {
                        scrollByContent: false
                    }
                });

                window.mStartDemarrage();
            }
            else { window.setTimeout(function () { func(); }, 50); }
        }
        func();

        //$(window).on('resize', function () {
        //    mResizeInterface()
        //});
    }
}

window.mInitMiseEnVeille = function () {
    jaugeMiseEnVeille = $("<div/>").appendTo("body").dxCtrlMiseEnVeille({}).dxCtrlMiseEnVeille("instance");
}

window.mConfirmFermetureNavigateur = function (e) {
    e.returnValue = "Etes vous sur de vouloir fermer cette fenêtre de l'application ?"
    return e.returnValue
}

window.classBackgroundColorBase = null;
window.themeLoaded = false;
window.theme = {};
window.styleDxCtrlHtmlEditorCmd = null;
window.styleDxSwitch = null;
window.lstFuncOnChangeTheme = []
window.mAddFunctionOnModifiedTheme = function (element, func) {
    var newFuncOnModified = function () {
        if (element.closest("body").length == 0) {
            return false;
        }
        else { func(); return true; }
    }
    lstFuncOnChangeTheme.push(newFuncOnModified)
}
window.mReadyTheme = function (funcFin) {

    const themeHref = `https://cdn3.devexpress.com/jslib/24.1.4/css/dx.${theme_uti_demarrage}.css?d=${(new Date()).getTime()}`;
    const $oldLink = $("#dx-theme");
    const $newLink = $("<link>", {
        id: "dx-theme",
        rel: "stylesheet",
        type: "text/css",
        href: themeHref
    });
    // Ajouter l’événement "load" correctement avec .on()
    $newLink.on("load", function () {
        $newLink.off("load")
        $oldLink.remove();
        mInitTheme()
    });

    $oldLink.after($newLink);



    //$("#dx-theme").on("load", function () {
    //    console.log("CSS chargé !");
    //    $("#dx-theme").off("load")
    //    mInitTheme()
    //}).attr("href", themeHref);

    function mInitTheme() {
        var $Div = $("<div class='dx-filterbuilder-range-separator'/>").appendTo("body");
        theme.color = $Div.css("color");
        if (theme.color.startsWith("rgba(")) {
            theme.color = theme.color.replace("rgba", "rgb")
            theme.color = theme.color.split(",")[0] + "," + theme.color.split(",")[1] + "," + theme.color.split(",")[1] + ")"
        }
        $Div.remove();
        var $Div = $("<div class='dx-toolbar-menu-section'/>").appendTo("body");
        theme.border = $Div.css("border-bottom");
        if (theme_uti_demarrage.contains(".light")) {
            theme.border = "1px solid rgb(200, 200, 200)"
        }
        theme.backgroundColorTitle = theme.border.split(" ")[2] + " " + theme.border.split(" ")[3] + " " + theme.border.split(" ")[4]
        $Div.remove();
        var $Div = $("<div class='dx-theme-accent-as-background-color'/>").appendTo("body");
        //theme.backgroundcolorAccent = 'rgb(206, 109, 223)'
        theme.backgroundcolorAccent = $Div.css("background-color");

        var match = theme.backgroundcolorAccent.match(/rgba?\((\d+),\s*(\d+),\s*(\d+),?\s*([\d.]*)\)/);
        if (match) {
            var r = parseInt(match[1]);
            var g = parseInt(match[2]);
            var b = parseInt(match[3]);
            var alpha = 0.3;

            var estClair = theme_uti_demarrage.includes(".light");
            var fond = estClair
                ? { r: 255, g: 255, b: 255 }  // thème clair : on éclaircit
                : { r: 0, g: 0, b: 0 };       // thème sombre : on fonce

            var R = Math.round(r * alpha + fond.r * (1 - alpha));
            var G = Math.round(g * alpha + fond.g * (1 - alpha));
            var B = Math.round(b * alpha + fond.b * (1 - alpha));
            theme.backgroundcolorWizardAnim = `rgb(${R}, ${G}, ${B})`;
        }


        theme.backgroundcolorAccentSelect = theme.backgroundcolorAccent.replace("rgb(", "rgba(").replace(")", ",0.5)")
        theme.borderColorGrille = theme.backgroundcolorAccent.replace("rgb(", "rgba(").replace(")", ",0.2)")
        $Div.remove();
        var $Div = $("<div class='dx-theme-material-typography'/>").appendTo("body");
        theme.backgroundcolorBase = $Div.css("background-color");
        $Div.remove();
        var $Div = $("<div class='dx-theme-as-background-color'/>").appendTo("body");
        theme.backgroundcolor = $Div.css("background-color");
        $Div.remove();
        var $Div = $("<div class='dx-tooltip-wrapper'><div class='dx-overlay-content'></div></div>").appendTo("body");
        theme.backgroundcolorTooltip = $Div.find(".dx-overlay-content").css("background-color");
        theme.backgroundcolorTooltipMoins = $Div.find(".dx-overlay-content").css("background-color").replace("rgb(", "rgba(").replace(")", ", 0.2)");
        theme.backgroundcolorSelect = theme.backgroundcolorTooltip.replace("rgb(", "rgba(").replace(")", ", 0.3)")

        var rgb = theme.backgroundcolorTooltip.match(/\d+/g).map(Number);
        rgb = rgb.map(function (v) { return Math.round(v * 0.8); });
        theme.backgroundcolorSelectSansOpacity = "rgb(" + rgb.join(",") + ")";
        theme.backgroundcolorSelectSansOpacity = "color-mix(in srgb, " + theme.backgroundcolorTooltip + ", white 25%)"

        theme.backgroundcolorSelectOpacity1 = theme.backgroundcolorTooltip.replace("rgb(", "rgba(").replace(")", ", 1)")
        if (theme_uti_demarrage.contains(".light")) {
            theme.backgroundcolorTooltip = "rgb(176,176,176)"
            var styleVirtualGridFixed = document.createElement("style");
            styleVirtualGridFixed.type = "text/css";
            document.getElementsByTagName("head")[0].appendChild(styleVirtualGridFixed);
            styleVirtualGridFixed.innerHTML = ""
                + ".dxctrlbuttonenveloppe .dx-button:hover { background-color:lightgray; }" //pour les ronds/texte hover
                + ".dx-button-mode-contained, .dx-button-mode-contained.dx-state-hover { box-shadow: 0 1px 5px rgba(0,0,0,.54); margin-top:1px; }" //pour les textes
                + ".dx-datagrid { color: black }"
                + ".dx-widget { color: black }"
                + ".dx-texteditor-label  { color: rgba(0,0,0,0.9) }"
        }

        var styleStateHoverNoClickLiight = ".state-hover-noclick-light:hover {background-color: rgba(220,220,220,1) !important;}"
        if (theme_uti_demarrage.contains(".dark")) styleStateHoverNoClickLiight = ".state-hover-noclick-light:hover {background-color: rgba(50,50,50,1) !important;}"
        var docStyleStateHoverNoClickLiight = document.createElement("style");
        docStyleStateHoverNoClickLiight.type = "text/css";
        document.getElementsByTagName("head")[0].appendChild(docStyleStateHoverNoClickLiight);
        docStyleStateHoverNoClickLiight.innerHTML = styleStateHoverNoClickLiight

        $Div.remove();
        var $Div = $("<div class='dx-toast-error'/>").appendTo("body");
        theme.toastError = $Div.css("background-color");
        $Div.remove();
        var $Div = $("<div class='dx-toast-warning'/>").appendTo("body");
        theme.toastWarning = $Div.css("background-color");
        $Div.remove();
        var $Div = $("<div class='dx-toast-success'/>").appendTo("body");
        theme.toastSuccess = $Div.css("background-color");
        $Div.remove();
        var $Div = $("<div class='dx-toast-info'/>").appendTo("body");
        theme.toastInfo = $Div.css("background-color");
        $Div.remove();
        var $Div = $("<div class='dx-widget'/>").appendTo("body");
        theme.fontcolor = $Div.css("color");
        $Div.remove();
        var $Div = $("<div class='dx-tab'/>").appendTo("body");
        theme.fontcolorInverse = $Div.css("background-color");
        $Div.remove();
        var $Div = $("<div class='dx-button dx-state-hover'/>").appendTo("body");
        theme.dxstatehover = $Div.css("background-color");
        $Div.remove();
        var $Div = $("<div class='dx-button dx-button-success dx-state-selected'/>").appendTo("body");
        theme.backgroundColorCompteur = $Div.css("background-color");
        $Div.remove();

        var r = parseInt(theme.backgroundcolorAccent.split(",")[0].replace("rgb(", ""))
        var g = parseInt(theme.backgroundcolorAccent.split(",")[1])
        var b = parseInt(theme.backgroundcolorAccent.split(",")[2].replace(")", ""))
        var r2 = Math.round(r + (255 - r) * 0.8);
        var g2 = Math.round(g + (255 - g) * 0.8);
        var b2 = Math.round(b + (255 - b) * 0.8);
        theme.grilleBackgroundColor = `rgb(${r2}, ${g2}, ${b2})`
        var r2 = Math.round(r * 0.8);
        var g2 = Math.round(g * 0.8);
        var b2 = Math.round(b + (255 - b) * 0.8);
        theme.grilleBackgroundColorRappel = "rgba(255, 255, 0, 0.7)"//`rgb(${r2}, ${g2}, ${b2})`
        if (theme_uti_demarrage.contains(".light")) {
            theme.grilleBackgroundColor = theme.backgroundcolorAccent.replace("rgb(", "rgba(").replace(")", ",0.2)")
        } else {
            theme.grilleBackgroundColor = theme.backgroundcolorAccent.replace("rgb(", "rgba(").replace(")", ",0.1)")
        }

        var styleTagBox = document.createElement("style");
        styleTagBox.type = "text/css";
        document.getElementsByTagName("head")[0].appendChild(styleTagBox);
        styleTagBox.innerHTML = "" +
            ".dx-tag-content { background-color:" + theme.grilleBackgroundColor + " }"

        //theme.grilleBackgroundColor.replace("rgb(", "rgba(").replace(")", ",0.3)")

        var styleVirtualGridFixed = document.createElement("style");
        styleVirtualGridFixed.type = "text/css";
        document.getElementsByTagName("head")[0].appendChild(styleVirtualGridFixed);
        styleVirtualGridFixed.innerHTML = "" +
            ".dx-state-hover { background-color:" + theme.dxstatehover + " }" +
            ".dx-mention { background-color:" + theme.backgroundcolorAccentSelect + "; font-family:barlow condensed; }"

        if (classBackgroundColorBase) classBackgroundColorBase.remove()
        classBackgroundColorBase = $("<style type='text/css'> .backgroundcolorbase { background-color:transparent} </style>").appendTo("head");

        var styleDropDownPopupBackgroud = document.createElement("style");
        styleDropDownPopupBackgroud.type = "text/css";
        document.getElementsByTagName("head")[0].appendChild(styleDropDownPopupBackgroud);
        styleDropDownPopupBackgroud.innerHTML = "" +
            ".dx-dropdowneditor-overlay .dx-list {" +
            "background-color:" + theme.backgroundcolorTooltip.replace("rgb(", "rgba(").replace(")", ",0.4)") + ";" +
            "border:" + theme.border + ";" +
            "}"

        if (classBackgroundColorBase) classBackgroundColorBase.remove()
        classBackgroundColorBase = $("<style type='text/css'> .backgroundcolorbase { background-color:transparent} </style>").appendTo("head");

        //creation theme dxCtrl
        if (styleDxCtrlHtmlEditorCmd) styleDxCtrlHtmlEditorCmd.remove();
        styleDxCtrlHtmlEditorCmd = document.createElement("style");
        styleDxCtrlHtmlEditorCmd.type = "text/css";
        styleDxCtrlHtmlEditorCmd.innerHTML = ".fr-toolbar .fr-command.fr-btn.fr-open:not(:hover):not(:focus):not(:active) { background-color: " + theme.backgroundcolorTooltip + "; }";
        document.getElementsByTagName("head")[0].appendChild(styleDxCtrlHtmlEditorCmd);

        //ajout theme pour le switch
        if (styleDxSwitch) styleDxSwitch.remove();
        styleDxSwitch = document.createElement("style");
        styleDxSwitch.type = "text/css";
        styleDxSwitch.innerHTML = ".dx-switch-off,.dx-switch-on { color: " + theme.color + "}";
        document.getElementsByTagName("head")[0].appendChild(styleDxSwitch);

        //ajout theme pour le hovertag
        var styleHover = document.createElement("style");
        styleHover.type = "text/css";
        styleHover.innerHTML = ".hovertag:hover { background-color: " + theme.dxstatehover + " !important;cursor: pointer !important;}";
        document.getElementsByTagName("head")[0].appendChild(styleHover);

        //ajout theme comptact pour padding-bottom saisie

        if (theme_uti_demarrage.endsWith(".compact")) {
            var styleEditeurPaddingBottom = document.createElement("style");
            styleEditeurPaddingBottom.type = "text/css";
            styleEditeurPaddingBottom.innerHTML = ".dx-editor-filled.dx-texteditor-with-floating-label .dx-lookup-field, .dx-editor-filled.dx-texteditor-with-floating-label .dx-placeholder::before, .dx-editor-filled.dx-texteditor-with-floating-label .dx-texteditor-input, .dx-editor-filled.dx-texteditor-with-label:not(.dx-texteditor-label-outside) .dx-lookup-field, .dx-editor-filled.dx-texteditor-with-label:not(.dx-texteditor-label-outside) .dx-placeholder::before, .dx-editor-filled.dx-texteditor-with-label:not(.dx-texteditor-label-outside) .dx-texteditor-input { padding-bottom:5px;}";
            document.getElementsByTagName("head")[0].appendChild(styleEditeurPaddingBottom);
        }

        //définir variable css
        $(':root').get(0).style.setProperty('--couleur-fond-bt-lig-grille', theme.backgroundcolorTooltip.replace("rgb(", "rgba(").replace(")", ", 0.6)"));

        theme.heightFont100 = null;
        var $DivFont = null;
        var func = function () {
            if (!$DivFont && $("body").length > 0) {
                $DivFont = $("<div style='position:absolute;top:-2000px;left:-2000px;font-size:100px;'>DFSFDSF</div>").appendTo("body");
            }
            else {
                window.setTimeout(function () { func() }, 50);
                return;
            }
            theme.heightFont100 = $DivFont.innerHeight();
            if (theme.heightFont100 == null || theme.heightFont100 == 0) {
                window.setTimeout(function () { func() }, 50);
            }
            else { $DivFont.remove(); }
        }
        func()
        var lstDel = []
        lstFuncOnChangeTheme.forEach(function (funcChange) {
            if (!funcChange()) lstDel.push(funcChange)
        })
        lstDel.forEach(function (funcChange) {
            lstFuncOnChangeTheme.splice(lstFuncOnChangeTheme.indexOf(funcChange), 1);
        })

        theme.colorBtIcon2 = theme.backgroundcolorAccent
        theme.colorBtIcon3 = "rgb(" + (255 - theme.backgroundcolorAccent.split("(")[1].split(",")[0]) + "," + (255 - theme.backgroundcolorAccent.split(",")[1]) + "," + (255 - theme.backgroundcolorAccent.split(",")[2].split(")")[0]) + ")"

        themeLoaded = true;

        funcFin()
    }

}



window.mAddButtonOkAnnuler = function (container, funcOk, funcAnnuler, textAnnuler, textOk, funcPlus, textFuncPlus, funcPlus2, textFuncPlus2) {
    var result = {}
    var $Table = $("<table/>").appendTo(container)
    result.table = $Table
    var $Tr = $("<tr/>").appendTo($Table);
    if (typeof funcPlus != "undefined" && funcPlus != null) {
        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
        result.btPlus1 = $("<div/>").appendTo($Td).dxCtrlButton({
            text: ((typeof textFuncPlus == 'undefined') ? "" : textFuncPlus),
            focusStateEnabled: false,
            onClick: function (e) {
                funcPlus(e)
            }
        }).dxCtrlButton("instance");
    }
    if (typeof funcPlus2 != "undefined" && funcPlus2 != null) {
        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
        result.btPlus2 = $("<div/>").appendTo($Td).dxCtrlButton({
            text: ((typeof textFuncPlus2 == 'undefined') ? "" : textFuncPlus2),
            focusStateEnabled: false,
            onClick: function (e) {
                funcPlus2(e)
            }
        }).dxCtrlButton("instance");
    }
    $("<td style='width:100%'/>").appendTo($Tr)
    if (typeof funcOk != 'undefined' && funcOk) {
        var $Td = $("<td style='width:1px;padding-right:5px' class='tdok'/>").appendTo($Tr)
        result.btOk = $("<div/>").appendTo($Td).dxCtrlButton({
            text: ((typeof textOk == 'undefined' || textOk == null) ? "Ok" : textOk),
            focusStateEnabled: false,
            onClick: function (e) {
                funcOk(e)
            }
        }).dxCtrlButton("instance");
    }

    if (typeof funcAnnuler != 'undefined' && funcAnnuler) {
        var $Td = $("<td style='width:1px' class='tdannuler'/>").appendTo($Tr)
        result.btCancel = $("<div/>").appendTo($Td).dxCtrlButton({
            text: ((typeof textAnnuler == 'undefined' || textAnnuler == null) ? "Annuler" : textAnnuler),
            focusStateEnabled: false,
            onClick: function (e) {
                funcAnnuler(e.component);
            }
        }).dxCtrlButton("instance");;
    }
    return result
}

window.lstEventMouseMove = [];
$(document).on('mousemove', function (e) {
    window.x = e.pageX
    window.y = e.pageY
    lstEventMouseMove.forEach(function (func) { func(e); });
    if (typeof lstEvent.mousemove != 'undefined') lstEvent.mousemove.forEach(function (func) {
        if (typeof func.remove != 'undefined' && func.remove()) { mRemoveEvent("mousemove", func) }
        else { func.exe(e); }
    });
});
window.lstEventResize = []
$(window).on("resize", function (e) {
    lstEventResize.forEach(function (func) { func(e); });
    if (typeof lstEvent.resize != 'undefined') lstEvent.resize.forEach(function (func) {
        if (typeof func.remove != 'undefined' && func.remove()) { mRemoveEvent("resize", func) }
        else { func.exe(e); }
    });
});

window.timeOutRemoveToast = null;
window.lstEventClick = []
$(window).on("click", function (e) {
    lstEventClick.forEach(function (func) { func(e); });
    if (typeof lstEvent.click != 'undefined') lstEvent.click.forEach(function (func) {
        if (typeof func.remove != 'undefined' && func.remove && func.remove()) { mRemoveEvent("click", func) }
        else {
            func.exe(e);
            if (func.unefois) mRemoveEvent("click", func)
        }
    });
});


window.lstEvent = {}
window.mAddEvent = function (nameEvent, funcExe, funcVerifAndRemove, uneFois) {
    if (typeof lstEvent[nameEvent] == "undefined") lstEvent[nameEvent] = []
    lstEvent[nameEvent].push({ exe: funcExe, remove: funcVerifAndRemove, unefois: ((typeof uneFois == 'undefined') ? false : uneFois) });
}
window.mRemoveEvent = function (nameEvent, funcObj) {
    lstEvent[nameEvent].splice(lstEvent[nameEvent].indexOf(funcObj), 1);
}

window.dateLastClick = new Date();

window.mousePosition = { x: -1, y: -1 };
jQuery(function ($) {
    $(document).mousemove(function (event) {
        mousePosition.x = event.pageX;
        mousePosition.y = event.pageY;
    });
});


//gestion du bug scrollheight de jquery
//app.ppmascaron.eu Uncaught TypeError: Cannot read properties of null (reading 'scrollHeight')
//https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js
//TypeError: Cannot read properties of null(reading 'scrollHeight')
//at https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js:2:87657
//at $(https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js:2:32538)
//at S.fn. [as height](https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js:2:87490)
//at Object.getPageHeight (https://conf.ppmascaron.eu/js/plugin/mousewheel/jquery.mousewheel.min.js?d=637059625080000000:5:1195)
//at HTMLDocument.setup (https://conf.ppmascaron.eu/js/plugin/mousewheel/jquery.mousewheel.min.js?d=637059625080000000:5:721)
//at Object.add (https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js:2:41504)
//at HTMLDocument. (https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js:2:40138)
//at S.each (https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js:2:2976)
//at S.fn.init.each (https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js:2:1454)
//at ke (https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js:2:40114)
(function ($) {
    var originalHeight = $.fn.height;
    $.fn.height = function () {
        if (!this[0]) return 0; // retourne 0 si l'élément n'existe pas
        return originalHeight.apply(this, arguments);
    };
})(jQuery);

window.isInAppMobile = function () {
    //if (parametre.isLocalhost) {return true }
    return window.location.href.startsWith("https://appmob.") || (parametre.isLocalhost && isFromAppLocalHost);
} //définit si l'application est exécuter dans une app (genre awInvitto)

window.mInitParametreMobileDesktop = function () {
    parametre.isPhone = (DevExpress.devices.current().deviceType == "phone");
    parametre.isTablette = (DevExpress.devices.current().deviceType == "tablet");
    parametre.isDesktop = (DevExpress.devices.current().deviceType == "desktop");
    parametre.isMobile = (DevExpress.devices.current().deviceType == "phone" || DevExpress.devices.current().deviceType == "tablet");

    if (window.location.host.startsWith("appphone.")) {
        parametre.isDesktop = false
        parametre.isPhone = true
        parametre.isTablette = false
        parametre.isMobile = true
    } else if (window.location.host.startsWith("apptablette.")) {
        parametre.isDesktop = false
        parametre.isPhone = false
        parametre.isTablette = true
        parametre.isMobile = true
    } else if (isInAppMobile()) {
        const width = window.innerWidth;
        if (width <= 768) {
            parametre.isDesktop = false
            parametre.isPhone = true
            parametre.isTablette = false
            parametre.isMobile = true
        } else {
            parametre.isDesktop = false
            parametre.isPhone = false
            parametre.isTablette = true
            parametre.isMobile = true
        }
    }
    if (parametre.isPhone) { parametre.device = "phone" }
    else if (parametre.isTablette) { parametre.device = "tablette" }
    else { parametre.device = "desktop" }
    //if (isTabletteLocalHost) {
    //    parametre.isDesktop = false
    //    parametre.isPhone = false
    //    parametre.isTablette = true
    //    parametre.isMobile = true
    //} else if (isPhoneLocalHost) {
    //    parametre.isDesktop = false
    //    parametre.isPhone = true
    //    parametre.isTablette = false
    //    parametre.isMobile = true
    //}
}

//var originalAppendTo = $.fn.appendTo;
//$.fn.appendTo = function (target) {
//    if (typeof parametre != 'undefined' && parametre.code_appli == "ppmasc") {
//        // Exemple : détecter si c'est "body"
//        if (target != null && (target === "body" || (target.jquery && target.is("body")))) {
//            if (typeof window.$DivGeneral != 'undefined' && window.$DivGeneral != null && window.$DivGeneral && window.$DivGeneral.is(":visible")) {
//                return originalAppendTo.call(this, window.$DivGeneral);
//            } else {
//                return originalAppendTo.call(this, target);
//            }
//        } else {
//            // Sinon on fait comme d’habitude
//            return originalAppendTo.call(this, target);
//        }
//    } else {
//        return originalAppendTo.call(this, target);
//    }
//};

//function mResizeInterface() {
//    if (typeof window.$DivGeneral != 'undefined' && window.$DivGeneral != null) {
//        var hViewport = $(window).height();
//        var wViewport = $(window).width();
//        var baseHeight = 911;

//        var scale = hViewport < baseHeight ? hViewport / baseHeight : 1;

//        window.$DivGeneral.css({
//            "transform-origin": "top left",
//            top: 0,
//            left:0,
//            transform: "scale(" + scale + ")",
//            width: (wViewport / scale) + "px",
//            height: (hViewport / scale) + "px"
//        });
//    }
//}